import { render, staticRenderFns } from "./UserProfileCard.vue?vue&type=template&id=46c52de6&"
import script from "./UserProfileCard.vue?vue&type=script&lang=js&"
export * from "./UserProfileCard.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileCard.vue?vue&type=style&index=0&id=46c52de6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports